export const USER_LOGIN_EXCEPTION = 'UserLoginException';
export const BAD_CREDENTIALS_EXCEPTION = 'BadCredentialsException';
export const RATE_LIMIT_AUTHENTICATION_EXCEPTION = 'RateLimitAuthenticationException';
export const NOT_FOUND_EXCEPTION = 'NotFoundException';

export const SIGN_IN_FAILED_PASSWORD_MISMATCH = 'SIGN_IN_FAILED_PASSWORD_MISMATCH';
export const SIGN_IN_FAILED_USER_NOT_FOUND = 'SIGN_IN_FAILED_USER_NOT_FOUND';
export const ACCESS_DENIED = 'ACCESS_DENIED';
export const ENTITY_NOT_FOUND_ERR = 'ENTITY_NOT_FOUND_ERR';

export const VIRTUAL_MFA = 'VIRTUAL_MFA';
export const EMAIL_MFA = 'EMAIL_MFA';

export const AUTH_ERROR_TEXT = {
  [USER_LOGIN_EXCEPTION]: {
    [SIGN_IN_FAILED_PASSWORD_MISMATCH]:
      'Incorrect password. Please try again or reset your password.',
    [SIGN_IN_FAILED_USER_NOT_FOUND]: 'No account found with this email.',
  },
  [RATE_LIMIT_AUTHENTICATION_EXCEPTION]: {
    [ACCESS_DENIED]:
      'Your access has been denied due to too many attempts. Please try again later.',
  },
  [BAD_CREDENTIALS_EXCEPTION]: {
    [ACCESS_DENIED]: 'Wrong verification code.',
  },
  [NOT_FOUND_EXCEPTION]: {
    [ENTITY_NOT_FOUND_ERR]:
      'Failed to send code to email: no account found. Please contact support.',
  },
  DEFAULT: 'Authentication failed: unexpected server error occurred. Please try again later.',
};
